import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StockDTO } from './stock.dto';

export class GetAllStockResponseModel extends GlobalResponseObject {
    data?: StockDTO[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: StockDTO[]){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}